import { useEffect, useState } from "react";
import DashSidebar from "@/components/DashSidebar";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

export default function AdminSettings() {
  const [settings, setSettings] = useState(null);

  const load = async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    }
  };

  useEffect(() => { load(); }, []);

  const toggle = async (field, value) => {
    try {
      const { data } = await api.put("/settings", { [field]: value });
      setSettings(data);
      toast.success("Settings updated");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    }
  };

  return (
    <div className="flex min-h-screen bg-[#F7F5F0]">
      <DashSidebar role="admin" />
      <main className="flex-1 lg:ml-0 ml-64 p-8 md:p-10">
        <h1 className="font-display text-3xl md:text-4xl font-semibold text-[#1A2E24] mb-1">Settings</h1>
        <p className="text-[#5C6B62] mb-8">Toggle outbound messaging.</p>

        {settings && (
          <div className="card-soft p-6 md:p-8 max-w-2xl space-y-5">
            <label className="flex items-start justify-between gap-4 cursor-pointer" data-testid="settings-email-toggle">
              <div>
                <div className="font-medium text-[#1A2E24]">Email delivery</div>
                <div className="text-sm text-[#5C6B62] mt-1">
                  When off, emails are logged only (mocked). When on (and keys are configured), real emails go out via the configured provider.
                </div>
              </div>
              <Switch checked={settings.enable_email} onCheckedChange={(v) => toggle("enable_email", v)} />
            </label>
            <div className="border-t border-[#E2DFD8]" />
            <label className="flex items-start justify-between gap-4 cursor-pointer" data-testid="settings-sms-toggle">
              <div>
                <div className="font-medium text-[#1A2E24]">SMS delivery</div>
                <div className="text-sm text-[#5C6B62] mt-1">
                  When off, SMS messages are logged only (mocked). When on (and keys are configured), real SMS messages go out via the configured provider.
                </div>
              </div>
              <Switch checked={settings.enable_sms} onCheckedChange={(v) => toggle("enable_sms", v)} />
            </label>

            <div className="mt-6 p-4 rounded-xl bg-[#9CAF88]/10 text-xs text-[#5C6B62]">
              <div className="font-medium text-[#2C4C3B] mb-1">Note</div>
              To actually deliver emails and SMS, add <code className="text-[#2C4C3B]">SendGrid</code> and <code className="text-[#2C4C3B]">Twilio</code> credentials in your environment and we'll connect them automatically. For now, all messages are safely mocked and stored for audit.
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
